export { default } from "./Segment.vue";
